// Minimal, safe inline formatting for the Notes/Chat compose boxes.
// Text is always HTML-escaped before any tag is reintroduced, so raw user
// input can never inject markup - only our own **/_/__ markers become tags.

const MARKERS = {
  bold: '**',
  italic: '_',
  underline: '__'
};

// Wraps the current selection (or inserts empty markers at the caret) in a
// <textarea> with the given marker, mirroring the ref's value/selection back.
export const applyFormat = (textareaRef, format) => {
  const el = textareaRef?.current;
  const marker = MARKERS[format];
  if (!el || !marker) return null;

  const { value, selectionStart, selectionEnd } = el;
  const selected = value.slice(selectionStart, selectionEnd);
  const before = value.slice(0, selectionStart);
  const after = value.slice(selectionEnd);
  const next = `${before}${marker}${selected}${marker}${after}`;

  const caretStart = selectionStart + marker.length;
  const caretEnd = caretStart + selected.length;

  return { value: next, selectionStart: caretStart, selectionEnd: caretEnd };
};

const escapeHtml = (text) =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

// Converts **bold**, __underline__, _italic_ markers into safe tags.
// Underline (__) is matched before italic (_) so it isn't consumed first.
export const renderFormattedText = (text) => {
  if (!text) return '';
  let html = escapeHtml(text);
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__([^_]+)__/g, '<u>$1</u>');
  html = html.replace(/_([^_]+)_/g, '<em>$1</em>');
  return html;
};
